import { OpportunityContext } from '@crm/contexts/OpportunityContext'
import { Spin } from 'antd'
import { useContext } from 'react'

import { LeadCard } from './LeadCard'

export const DetailsCol = () => {
  const { lead, isLoading } = useContext(OpportunityContext)

  return <Spin spinning={isLoading}>{lead && <LeadCard lead={lead} />}</Spin>
}
